class MobileProductSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.mobile-product-slider__track');
    this.slides = Array.from(el.querySelectorAll('.mobile-product-slider__slide'));
    this.currentEl = el.querySelector('.mobile-product-slider__current');
    this.prevBtn = el.querySelector('.mobile-product-slider__btn--prev');
    this.nextBtn = el.querySelector('.mobile-product-slider__btn--next');
    this.total = this.slides.length;
    this.index = 0;

    if (this.total < 2) return;

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.isDragging = false;
    this.isHorizontal = null;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1));

    this.track.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
    this.track.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });
    this.track.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });

    this.updateButtons();
  }

  goTo(index) {
    this.index = Math.max(0, Math.min(index, this.total - 1));
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    if (this.currentEl) this.currentEl.textContent = this.index + 1;
    this.updateButtons();
  }

  updateButtons() {
    if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index === this.total - 1;
  }

  onTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.isDragging = true;
    this.isHorizontal = null;
    this.track.style.transition = 'none';
  }

  onTouchMove(e) {
    if (!this.isDragging) return;

    const dx = e.touches[0].clientX - this.touchStartX;
    const dy = e.touches[0].clientY - this.touchStartY;

    if (this.isHorizontal === null) {
      if (Math.abs(dx) > Math.abs(dy)) {
        this.isHorizontal = true;
      } else if (Math.abs(dy) > 5) {
        this.isHorizontal = false;
      }
    }

    if (this.isHorizontal) {
      e.preventDefault();
      const offset = -(this.index * 100) + (dx / this.el.offsetWidth) * 100;
      this.track.style.transform = `translateX(${offset}%)`;
    }
  }

  onTouchEnd(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.transition = '';

    if (!this.isHorizontal) return;

    const dx = e.changedTouches[0].clientX - this.touchStartX;
    const threshold = this.el.offsetWidth * 0.2;

    if (dx < -threshold) {
      this.goTo(this.index + 1);
    } else if (dx > threshold) {
      this.goTo(this.index - 1);
    } else {
      this.goTo(this.index);
    }
  }
}

document.querySelectorAll('.mobile-product-slider').forEach((el) => {
  new MobileProductSlider(el);
});
